document.addEventListener("DOMContentLoaded", () => {
  console.log("Infinite scroll script loaded");
  
  // Check if more products are available
  const hasMoreProducts = () => {
    const nextPageUrlElement = document.querySelector("[next-url]");
    const nextPageUrl = nextPageUrlElement?.getAttribute("next-url");
    return nextPageUrl && nextPageUrl.trim() !== "";
  };

  const loadMoreProducts = async () => {
    const productGrid = document.getElementById("product-grid");
    const loadingOverlay = document.querySelector(
      ".collection-loading-overlay"
    );
    let nextPageUrlElement = document.querySelector("[next-url]");
    let nextPageUrl = nextPageUrlElement?.getAttribute("next-url");

    if (!nextPageUrl) {
      console.log("No more pages to load.");
      return; // Stop execution if there are no more pages
    }

    loadingOverlay.style.display = "flex"; // Show the loading overlay
    try {
      const response = await fetch(nextPageUrl); // Fetch the next page of products
      const data = await response.text();
      // Parse the new HTML and extract the updated 'next-url' and product grid
      const newDoc = new DOMParser().parseFromString(data, "text/html");
      const newProducts = newDoc.querySelector("#product-grid");

      const nextUrl = newDoc
        .querySelector("[next-url]")
        ?.getAttribute("next-url");
      console.log("Updated next-url:", nextUrl); // For debugging
     
      if (newProducts) {
        console.log(newProducts, 'new products');
        console.log(productGrid, 'product grid')
        // Append the new products to the existing product grid
        productGrid.insertAdjacentHTML("beforeend", newProducts.innerHTML);

        if (nextUrl) {
          nextPageUrlElement.setAttribute("next-url", nextUrl);
        } else {
          nextPageUrlElement.removeAttribute("next-url"); // Prevent further calls
          console.log("Reached the last page.");
        }

        // Only create observer if there are still more products to load
        if (hasMoreProducts()) {
          createObserver();
        }
      }
    } catch (err) {
      console.error("Failed to load more products:", err);
    } finally {
      loadingOverlay.style.display = "none"; // Hide the loading overlay
    }
  };

  const createObserver = () => {
    // Only create observer if there are more products to load
    if (!hasMoreProducts()) {
      console.log("No more products available - observer not created");
      return;
    }

    const productGrid = document.querySelector("#product-grid");
    if (!productGrid) return;
    
    const observerPagination = new IntersectionObserver(
      (entries, observer) => {
        if (entries[0].isIntersecting) {
          loadMoreProducts();
          observer.disconnect();
        }
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 1.0,
      }
    );
    
    const observeLastProduct = () => {
      const lastProduct = productGrid.lastElementChild;
      if (lastProduct) {
        observerPagination.observe(lastProduct);
      }
    };
    observeLastProduct();
  };

  const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      if (mutation.type === "childList") {
        if (typeof isSingleColumnState !== 'undefined' && isSingleColumnState) {
          document
            .querySelector("#product-grid")
            .classList.add("single-toggle");
          document
            .querySelectorAll("#product-grid .grid__item")
            .forEach((elem) => {
              elem.classList.add("single-toggle");
            });
        }
        // Only create observer if there are more products to load
        if (hasMoreProducts()) {
          createObserver();
        }
      }
    });
  });

  const productGrid = document.getElementById("ProductGridContainer");
  if (productGrid) {
    observer.observe(productGrid, {
      childList: true,
    });
  }

  // Initial observer creation - only if there are more products
  if (hasMoreProducts()) {
    createObserver();
  } else {
    console.log("Collection has no more products - infinite scroll disabled");
  }
});